import { createContext } from 'react';

import { DataPoint } from '../../core/types/data-point.js';
import type { AxisIdToScaleDomain } from '../types/xy-chart-internals.js';
import type { XYChartSelectionDotMetadata } from '../types/xy-chart-selection.js';
import { AxisIdToScales } from './XYChartScales.context.js';

export interface XYChartLinearSelectionContextValue {
  hasDatapoints: boolean;
  searchAllAxisDatapoints: (
    start: number,
    end: number,
    callback: (
      point: XYChartSelectionDotMetadata,
    ) => DataPoint | DataPoint[] | null,
    axesIds: string | string[],
    axisIdToScales: AxisIdToScales,
    axisIdToScaleDomain: AxisIdToScaleDomain,
    axisIdToIsRelative: Map<string, boolean>,
  ) => {
    axesCurrentSelection: Record<string, DataPoint[]>;
    highlightedDatapoints: DataPoint[];
  };
}

export const XYChartLinearSelectionContext = createContext<
  XYChartLinearSelectionContextValue | undefined
>(undefined);
